import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, useOverlayContext } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import NotificationActionLayout, { NotificationActionLayoutType } from '~/components/NotificationActionLayout/NotificationActionLayout';
import { routes } from '~/constants';
import { useIoContext } from '~/contexts';
import { useLocaleKeys } from '~/i18n';
import { ServerError, errorTextsPath } from '~/infra/ErrorResponse';
import { handleRequest } from '~/infra/utils';
import { useStoreActions } from '~/store/store-context';
export const GetApproveTeamMemberInvitationTID = (parentTestId)=>getTestIds({
        parentTestId,
        deprecatedTestIds: {
            ApproveTeamMemberInvitationTID: {
                Root: 'approve-team-member-invitation-page',
                HeaderText: 'notification-before-action-header-text',
                ErrorToast: 'error-toast'
            }
        }
    });
export const ApproveTeamMemberInvitation = (param)=>{
    let { invitingUserName, invitingUserEmail, invitingBusinessName, invitingBusinessId, invitationId } = param;
    const { api } = useStoreActions();
    const [loading, setLoading] = useState(false);
    const { showErrorToast } = useOverlayContext();
    const navigate = useNavigate();
    const { cookies } = useIoContext();
    const { setAuthToken } = useStoreActions();
    const { t: errorTexts } = useLocaleKeys(errorTextsPath);
    const { t: notifTexts } = useLocaleKeys('notification.action');
    const { ApproveTeamMemberInvitationTID } = useMemo(()=>GetApproveTeamMemberInvitationTID(), []);
    async function sendApproveTeamMemberInvitation() {
        setLoading(true);
        const { success, error } = await handleRequest(api.business.acceptTeamInvite({
            invitationId,
            businessId: invitingBusinessId
        }));
        if (success) {
            // the accept team invite will update the auth token to the new vendor business
            await setAuthToken(cookies.getAuthToken());
            navigate(routes.home);
        } else {
            const errorText = error.hasServerError(ServerError.InvalidTeamInvitation) ? error.invalidTeamInvitationErrorText(errorTexts) : notifTexts.teamMemberApprovalFailed();
            showErrorToast(errorText, ApproveTeamMemberInvitationTID.ErrorToast());
        }
        setLoading(false);
    }
    return /*#__PURE__*/ _jsx(Box, {
        testId: ApproveTeamMemberInvitationTID.Root(),
        style: {
            height: '100%'
        },
        children: /*#__PURE__*/ _jsx(NotificationActionLayout, {
            hideSignInLink: true,
            state: loading ? {
                type: NotificationActionLayoutType.Loading
            } : {
                type: NotificationActionLayoutType.BeforeAction,
                beforeAction: {
                    header: /*#__PURE__*/ _jsxs(Typography, {
                        variant: "h5",
                        testId: ApproveTeamMemberInvitationTID.HeaderText(),
                        as: "span",
                        children: [
                            /*#__PURE__*/ _jsxs(Typography, {
                                variant: "h5",
                                weight: "bold",
                                as: "span",
                                children: [
                                    invitingUserName,
                                    ' '
                                ]
                            }),
                            "(",
                            invitingUserEmail,
                            ")",
                            notifTexts.invitationMiddle(),
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: "h5",
                                weight: "bold",
                                as: "span",
                                children: invitingBusinessName
                            }),
                            notifTexts.invitationSuffix(),
                            /*#__PURE__*/ _jsx("br", {}),
                            notifTexts.clickToAccept()
                        ]
                    }),
                    buttonText: notifTexts.acceptInvitation(),
                    onClick: sendApproveTeamMemberInvitation
                }
            }
        })
    });
};
